import { kzs as _kzs } from "@kaizenplatform/cse-tools";
import { setGoals } from "src/module/goals";
import { applyDesign } from "./variations/applyDesign";
import { addEstimateResult } from "src/variations/addEstimateResult";
import { changeFloatingCta } from "src/variations/changeFloatingCta";
import History, { updateHistory } from "src/module/history/history";
import Estimate, { updateEstimate } from "src/module/estimate/estimate";

const kzs = window.kzs;
const $ = kzs.$;
kzs.console.log("kzs.$.fn.jquery:", $.fn.jquery);

const expScript = (context: _kzs.precedingJsContext): Promise<void> => {
  kzs.console.log("context", context);
  const Promise = kzs.Promise;

  return Promise.resolve()
    .then(
      // doc readyを待つ
      () => new Promise<void>((resolve) => $(() => resolve()))
    )
    .then(() => {
      const url = location.href.replace(location.search, "");
      if (url == "https://sp.subaru.jp/" || url == "https://www.subaru.jp/") {
        // TOPページの場合
        // ゴール設定
        setGoals(context.variation.isOriginal);

        window.kzVariations = {
          applyDesign: () => {
            applyDesign();
          },
          addEstimateResult: () => {
            addEstimateResult();
          },
          changeFloatingCta: () => {
            changeFloatingCta();
          },
        };
      } else if (url == "https://members.subaru.jp/estimate_simulation/index.html") {
        // 見積りシミュレーション結果保存
        updateEstimate(Estimate);
      } else {
        // 閲覧履歴を更新
        updateHistory(History);
      }
    });
};

export default expScript;
